import { colors } from '../styles';
import { globalColor } from '../utils/globals';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

const BannerWrapper = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 999;
    background-color: ${() => globalColor.backgroundColor2};
    color: ${colors.white};
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding: 6px 16px;
    font-size: 13px;
    font-family: 'Open Sans', sans-serif;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
    box-sizing: border-box;
`;

const ReporteeName = styled.span`
    font-weight: 600;
    margin-left: 4px;
`;

const HIDDEN_PAGE_SUFFIXES = ['/introduction', '/reportees'];

const isHiddenPage = (pathname: string): boolean => {
    if (HIDDEN_PAGE_SUFFIXES.some((suffix) => pathname.endsWith(suffix))) {
        return true;
    }
    const segments = pathname.split('/').filter(Boolean);
    return segments.length <= 2;
};

const ReporteeBanner: React.FC = () => {
    const { t } = useTranslation(['ReporteesList']);
    const location = useLocation();
    const isManagerFlow = sessionStorage.getItem('isManagerFlow') === 'true';
    const reporteeName = sessionStorage.getItem('selectedReporteeName');

    if (!isManagerFlow || !reporteeName || isHiddenPage(location.pathname)) {
        return null;
    }

    return (
        <BannerWrapper>
            {t('bannerLabel')}
            <ReporteeName>{reporteeName}</ReporteeName>
        </BannerWrapper>
    );
};

export default ReporteeBanner;
